import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Tpl3plService } from '../../../services/tpl3pl.service';
import { GlobalSearchService } from '../../../services/globalsearchservice.service';

@Component({
	selector: 'app-tpl3pl-dashboard',
	templateUrl: './tpl3pl-dashboard.component.html',
	styleUrls: ['./tpl3pl-dashboard.component.scss']
})
export class Tpl3plDashboardComponent implements OnInit, OnDestroy {
	status: any = null;
	loading = false;
	private configSavedSub: Subscription | null = null;

	constructor(
		private tpl3plService: Tpl3plService,
		private globalSearchService: GlobalSearchService
	) {}

	ngOnInit(): void {
		this.loadStatus();
		this.configSavedSub = this.tpl3plService.configSaved$.subscribe(() => this.loadStatus());
	}

	ngOnDestroy(): void {
		this.configSavedSub?.unsubscribe();
	}

	loadStatus(): void {
		this.loading = true;
		this.tpl3plService.getStatus().subscribe({
			next: (result) => {
				this.status = result;
				this.loading = false;
			},
			error: (error) => {
				this.globalSearchService.showNotification('Error loading integration status', 'danger', 'bottom', 'right');
				this.loading = false;
			}
		});
	}
}
